import { MeetingSource } from '@vendasta/meetings';

export enum AvailableServices {
  ZOOM = MeetingSource.MEETING_SOURCE_ZOOM,
  GOOGLE_MEET = MeetingSource.MEETING_SOURCE_GOOGLE_MEET,
  MICROSOFT = MeetingSource.MEETING_SOURCE_MICROSOFT,
}
